// extracted by mini-css-extract-plugin
module.exports = {"container":"Highlight_container__HwwKC","title":"Highlight_title__jqA3E","thumbnail":"Highlight_thumbnail__72v2N","text":"Highlight_text__0w8GZ"};